export function isStatusOk(res: any): boolean {
  return (
    res &&
    res.status &&
    res.status.code &&
    res.status.code === 'STATUS_OK'
  ) as boolean;
}
